import React, { useState } from 'react';

function DynamicContent() {
  const [count, setCount] = useState(0);

  return (
    <div>
      <h2>Dynamic Content</h2>
      <p>Current count: {count}</p>
      <button onClick={() => setCount(count + 1)}>Increment</button>
    </div>
  );
}

export default DynamicContent;
